<div class="contact-page animated fadeIn">

  <div class="container">

    <div class="row agent-row d-flex justify-content-center">

      <ng-container *ngFor="let seller of realEstateAgents">
        <div class="col-12 col-md-6 col-lg-3">
          <mat-card>
            <div class="ui card">
              <div class="profile-image" [ngStyle]="getBackgroundImageStyle(seller)"></div>
              <div class="content">
                <div class="header">{{seller.name}}</div>
                <div class="description">
                  {{seller.title}}
                </div>
              </div>
              <div class="extra content">
                <div class="contact-line overflow-ellipsis" (click)="openPhone(seller.phone)">
                  <i class="phone icon"></i>
                  {{seller.phone}}
                </div>
                <div class="contact-line overflow-ellipsis" (click)="openMail(seller.email)">
                  <i class="mail icon"></i>
                  {{seller.email}}
                </div>
              </div>
            </div>

          </mat-card>

        </div>
      </ng-container>
    </div>

  </div>

  <app-contact-section></app-contact-section>


</div>

